import React from 'react';
import PropTypes from 'prop-types';
import {BlocksControls, InlineBlocks} from 'react-tinacms-inline';
import {box, text} from '../../constants/fields/fields';
import {Feature} from './Feature';
import {featuresTemplate} from '../../constants/templates/features';
import {FeatureListStyled} from './FeatureListStyled';
import {useBlockProps} from '../../hooks/useBlockProps';


const FEATURE_BLOCKS = {
  feature: Feature,
};


function FeatureListComponent({index, data}) {
  const {blockProps} = useBlockProps(data);
  return (
    <BlocksControls index={index} focusRing={{offset: 0}} insetControls>
      <FeatureListStyled {...blockProps}>
        <InlineBlocks
          name="blocks"
          blocks={FEATURE_BLOCKS}
          direction={'horizontal'}
          className="dfl-feature-list"
        />
      </FeatureListStyled>
    </BlocksControls>
  );
}

const template = {
  label: 'Feature',
  defaultItem: featuresTemplate,
  fields: [
    text,
    box
  ]
};
export const Features = {
  Component: FeatureListComponent,
  template
};

FeatureListComponent.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number
};
